import { createProxyApiClient } from '@/lib/proxy-api-client';

const passwordResetApi = createProxyApiClient({
  baseURL: '/api/public-app-data/v1/password-reset',
  requireAuthBootstrap: false,
});

export function getPasswordResetApi() {
  return passwordResetApi;
}
